import { Pipe, PipeTransform } from '@angular/core';

import { EmsPowerBalanceProperties, Feature } from '../../../../projects/client';
import { NO_VALUE } from '../../../shared/pipes/dash/dash.pipe';

@Pipe({
  name: 'calculationStatus',
})
export class CalculationStatusPipe implements PipeTransform {
  transform(
    value: number | string,
    args: Feature<EmsPowerBalanceProperties, never>
  ): number | string {
    if (
      value != null &&
      (args?.properties?.calculationStatus?.value === 'correct' ||
        args?.properties?.calculationStatus?.value === 'adjusted')
    ) {
      return value;
    }

    return NO_VALUE;
  }
}
